@if (showNav()) {
  <mbs-table-nav
    [customContent]="navContent"
    [customControls]="customControls"
    [disableScrollTopOnPageChange]="disableScrollTopOnPageChange || !!maxHeight"
    [disableViewSwitch]="disableViewSwitch"
    [filters]="filters"
    [fullContentWidth]="fullContentWidth"
    [paginationOptions]="paginationOptions"
    [showExportToCSVButton]="showExportToCSVButton"
    [showRefreshButton]="showRefreshButton"
    [switcherView]="switcherView"
    [viewMode]="myViewMode"
    [wideContentMode]="wideContentMode"
    (pageSizeChange)="handleChangePageSize($event)"
    (pageSwitch)="onPageSwitch($event)"
    (refresh)="refresh.emit()"
    (viewChange)="onViewChange($event)" />
}

@if (showTopControls) {
  <div class="mbs-table-grid_accordion_controls">
    <div class="row align-items-center justify-content-between">
      <div class="col-auto mbs-table-grid_accordion_controls-checkbox">
        @if (data?.length > 0) {
          <mbs-checkbox
            [checked]="checkedTop"
            [disabledSelf]="topControlsDisabled"
            [indeterminate]="indeterminateTop"
            [label]="topControlsLabel"
            (change)="topControlsCheckboxChangeHandler($event)" />
        }
      </div>

      @if (topControlsDescription; as description) {
        <div class="col-auto mbs-table-grid_accordion_controls-description">
          {{ description }}
        </div>
      }
    </div>
  </div>
}

<ng-template #topControlsLabel>
  <ng-template [ngTemplateOutlet]="prependTopControlsLabel?.template" />

  @if (topControlsLabelSelected) {
    <span>
      {{ selectedItems?.length }}
    </span>
  }

  <ng-template [ngTemplateOutlet]="appendTopControlsLabel?.template" />
</ng-template>

<div
  class="mbs-table-grid-wrapper"
  [class.-invalid]="invalid && displayData.length"
  [class.h-100]="flexMode()">
  @if (myViewMode === sharedPersistentStateEnum.table) {
    <mbs-table
      [arrayRowsWithClasses]="arrayRowsWithClasses"
      [bindChildren]="bindChildren"
      [bindDisabledValues]="bindDisabledValues"
      [bindKeyForRowClass]="bindKeyForRowClass"
      [bindParentKey]="bindParentKey"
      [bindSelected]="bindSelected"
      [bindSelectedChildren]="bindSelectedChildren"
      [bordered]="borderedTable"
      [cancelSelectionText]="cancelSelectionText"
      [canSelectParent]="canSelectParent"
      [changeSortState]="changeSortState"
      [checkboxCellWidth]="checkboxCellWidth"
      [childHeaderClasses]="childHeaderClasses"
      [childrenTemplates]="childrenTemplates"
      [childRowsClasses]="childRowsClasses"
      [classesTable]="classesTable"
      [collapsibleMode]="collapsibleMode"
      [data]="displayData"
      [dependenceChildren]="dependenceChildren"
      [disableChildren]="disableChildren"
      [entityName]="entityName"
      [getCustomRowClasses]="getCustomRowClasses"
      [getItems]="getItems"
      [headers]="headers"
      [headerTemplates]="$any(headerTemplates)"
      [height]="height"
      [highlightContextMenuRow]="highlightContextMenuRow"
      [highlightOpened]="highlightOpened"
      [hover]="hoverTable"
      [infiniteScroll]="infiniteScroll"
      [infiniteScrollDistance]="infiniteScrollDistance"
      [infiniteScrollLoading]="infiniteScrollLoading"
      [infiniteScrollThrottle]="infiniteScrollThrottle"
      [initialOpenedCollapsibleItems]="initialOpenedCollapsibleItems"
      [keepState]="keepState"
      [layoutMode]="layoutMode()"
      [lazy]="lazy"
      [loadedChildren]="loadedChildren"
      [loaderType]="loaderType"
      [loading]="loading"
      [maxBufferPx]="maxBufferPx"
      [maxHeight]="maxHeight"
      [maxVirtualScrollItemSize]="maxVirtualScrollItemSize"
      [minBufferPx]="minBufferPx"
      [minHeight]="minHeight"
      [minVirtualScrollItemSize]="minVirtualScrollItemSize"
      [multipleSelect]="multipleSelect"
      [multipleSelectType]="multipleSelectType"
      [myTrackBy]="myTrackBy"
      [needChildrenPaddingLeft]="needChildrenPaddingLeft"
      [needToggleOnEndRow]="needToggleOnEndRow"
      [noDataMessage]="noDataMessage"
      [rotateSequence]="rotateSequence"
      [rowClasses]="rowClasses"
      [rowContextMenu]="rowContextMenu"
      [scrollWindow]="scrollWindow"
      [selectable]="selectable"
      [selectAllButtonText]="selectAllButtonText"
      [selectAllIgnoreDisabled]="selectAllIgnoreDisabled"
      [selectedCountText]="selectedCountText"
      [selectedItems]="selectedItems"
      [selectOnlyOnCheckboxClick]="selectOnlyOnCheckboxClick"
      [selectRowClass]="selectRowClass"
      [showCheckboxes]="showTableCheckboxes"
      [showCheckboxesForChildren]="showCheckboxesForChildren"
      [showChildrenHeaders]="showChildrenHeaders"
      [showHeaders]="showHeaders"
      [showSelectAllCheckbox]="showSelectAllCheckbox"
      [showSelectAllHint]="showSelectAllHint"
      [size]="sizeTable"
      [staticHeightIfVoidData]="staticHeightIfVoidData"
      [stickyColumnWithVR]="stickyColumnWithVR"
      [stickyHeader]="stickyHeader"
      [striped]="stripedTable"
      [subtitleHeaders]="subtitleHeaders"
      [templates]="cellTemplates"
      [toggleCellWidth]="toggleCellWidth"
      [tooltipForDisabledRow]="tooltipForDisabledRow"
      [totalItems]="paginationOptions?.dataSize || totalItems"
      [totalSelectedItems]="totalSelectedItems"
      [underHeaderTemplate]="underHeaderTemplate"
      [useFixedDocumentSpinner]="useFixedDocumentSpinner"
      [virtualItemSize]="virtualItemSize"
      [virtualItemsNumber]="virtualItemsNumber"
      [virtualScrolling]="virtualScrolling"
      [virtualScrollItemSizeDivider]="virtualScrollItemSizeDivider"
      (changeSelected)="handleSelectedRow($event)"
      (clickTableElement)="handleClickTableElement($event)"
      (scroll)="scroll.emit($event)"
      (scrolled)="scrolled.emit()"
      (scrollEnd)="scrollEnd.emit()"
      (selectAllOnAllPages)="setTotalSelectedItems($event)"
      (sort)="handleSort($event)" />
  }

  @if (myViewMode === sharedPersistentStateEnum.grid) {
    <mbs-grid
      [bindSelected]="bindSelected"
      [bindSelectedChildren]="bindSelectedChildren"
      [data]="displayData"
      [headers]="headers"
      [headerTemplate]="$any(gridHeaderTemplate)"
      [isNeedSelectCard]="enableCardSelection && selectable"
      [loaderType]="loaderType"
      [loading]="loading"
      [maxHeight]="maxHeight"
      [minHeight]="minHeight"
      [multipleSelect]="multipleSelect"
      [multipleSelectType]="multipleSelectType"
      [myTrackBy]="$any(myTrackBy)"
      [noDataMessage]="noDataMessage"
      [selectCardClass]="selectCardClass"
      [selectedCards]="selectedItems"
      [templates]="$any(cellTemplates)"
      [tileTemplate]="tileTemplate"
      (changeSelectedCards)="handleSelectedRow($event)"
      (clickTableElement)="handleClickTableElement($event)" />
  }
</div>
